<template>
  <div id="app">
    <div id="hi-container"></div>

    <div class="display-large-image" v-show="imageUrl != ''" style="z-index: 9999999;">
      <img id="the-popover-image" :src="imageUrl" style="pointer-events: none; position: absolute; margin: 0; padding: 0; z-index: 9999999; background-color: #fff; border: #cacaca 1px solid" >
    </div>
    <v-component v-bind:is="layout"></v-component>

    <TheModal/>
    <TheAlert/>

    <span class="tooltip"></span>

    <div class="modal-container" :class="{'active': expireConfirmActive}">
      <div class="modal-window small" :class="{'active': expireConfirmActive}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Vil du fortsatt være logget inn?</h3>
            <br>
          </div>
        </div>
        <div class="modal-window-body gray">
          <p>
            <span class="opacity-80">Du blir automatisk logget ut fra Avanti grunnet inaktivitet om <b>{{tokenExpiresIn}}</b> sekunder.</span>
          </p>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button href="javascript:;" class="button primary transparent modal-close" @click="onExpireCancel()">
                Nei
              </button>
              <button v-if="!refreshing" href="javascript:;" class="button primary submit" @click="onExpireRefresh()">
                Ja
              </button>
              <button v-else href="javascript:;" class="button primary submit loading">
                <span>Ja <span class="loader-spinner"></span></span>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="onExpireCancel()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="expireConfirmActive" class="modal-overlay"></div>
    </div>
  </div>
</template>

<script>
import GuestLayout from './layouts/GuestLayout'
import AdminLayout from './layouts/AdminLayout'
import TheModal from './components/TheModal'
import TheAlert from './components/TheAlert'

import bus from '@/plugins/event-bus'
import { AUTH_LOGOUT, AUTH_REFRESH, CHECK_TOKEN } from './store/actions/auth'

// Show alert when 1 min left
const ALERT_SECS = 60

export default {
  name: 'App',
  data () {
    return {
      imageUrl: false,
      counterId: null,
      refreshing: false,
      tokenExpiresIn: 0,
      expireConfirmActive: false
    }
  },
  components: {
    GuestLayout,
    AdminLayout,
    TheModal,
    TheAlert
  },
  async created () {
    // Attach the sticky headers js file
    let vm = this
    let t = 'script'
    let s = document.getElementsByTagName(t)[0]
    let e = document.createElement(t)

    bus.$on('hover-image', function (data) {
      window.jQuery('#the-popover-image').hide()

      if (data.event) {
        window.jQuery('#the-popover-image').css({
          position: 'absolute',
          left: data.event.pageX + 50,
          top: data.event.pageY - 25
        })

        vm.imageUrl = data.imageUrl

        setTimeout(function () {
          window.jQuery('#the-popover-image').show()
        })
      } else {
        vm.imageUrl = data.imageUrl
      }
    })

    // Add sticky tabel headers...
    e.type = 'text/javascript'
    e.src = '/static/jquery.stickytableheaders.min.js'
    s.parentNode.insertBefore(e, s)

    // Add jira script
    t = 'script'
    s = document.getElementsByTagName(t)[0]
    e = document.createElement(t)
    e.type = 'text/javascript'
    e.src = 'https://bqdrift.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-ia3qmx/b/9/b0105d975e9e59f24a3230a22972a71a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=ed61f345'
    s.parentNode.insertBefore(e, s)
  },
  mounted () {
    if (this.$store.getters.isLoggedIn) {
      this.startCounter()
    }

    // Hover effect object photos
    const $hiContainer = window.jQuery('#hi-container')

    setTimeout(function () {
      window.jQuery(document).delegate('.hi-trigger', 'mouseenter', function () {
        // defining the container element
        var $hiSrc = null

        // use data-attribute 'data-hi-src' for full size image if possible
        if (window.jQuery(this).data('hi-src-full')) {
          $hiSrc = window.jQuery(this).attr('data-hi-src-full')
        } else {
          $hiSrc = window.jQuery(this).attr('src')
        }

        // fetch the container size via data attribute. default to 'large' (available sizes: small, medium, large, xlarge)
        var $hiSize = window.jQuery(this).attr('data-hi-size')

        // defining offset and position variables
        var $offsetTop = window.jQuery(this)[0].getBoundingClientRect().top
        var $offsetHeight = window.jQuery(this).height()
        var $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
        var $hiContainerHeight = $hiContainer.height()
        // var $hiContainerWidth = $hiContainer.width()

        // prepend the image tag if it does not exist
        if (!$hiContainer.children('img').length) {
          $hiContainer.prepend('<img src="' + $hiSrc + '"/>')
        } else {
          // else update the tag with new src
          $hiContainer.children('img').attr('src', $hiSrc)
        }

        // update the size class
        $hiContainer.removeClass()
        $hiContainer.addClass($hiSize)

        // show the image container if not already active
        if (!$hiContainer.hasClass('active')) {
          $hiContainer.addClass('active')

          window.jQuery(document).bind('mousemove', function (e) {
            // making sure the hover image containers height is not taller than the remaining viewport bottom space
            if ($offsetBottom > $hiContainerHeight) {
              $hiContainer.css({
                left: e.clientX + 40,
                top: e.clientY + 40
              })
            } else {
              // offset the card if to close to bottom
              $hiContainer.css({
                left: e.clientX + 40,
                top: e.clientY - $hiContainerHeight - 20
              })
            }
          })
        }
      })

      window.jQuery(document).delegate('.hi-trigger', 'mouseleave', function () {
        $hiContainer.removeClass('active')
        window.jQuery(document).unbind('mousemove', function (e) {})
      })
    })
  },
  watch: {
    'loggedIn': function (newVal) {
      if (newVal) {
        this.startCounter()
      } else {
        this.stopCounter()
      }
    }
  },
  computed: {
    layout () {
      // Just for page reloads, so we don't get wrong content
      if (this.$store.getters.isPageLoading) {
        return ''
      }

      return this.$store.getters.isLoggedIn ? 'admin-layout' : 'guest-layout'
    },
    loggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    onExpireCancel: function () {
      this.stopCounter()
      this.expireConfirmActive = false
      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push('/')
    },
    onExpireRefresh: function () {
      this.refreshing = true
      this.stopCounter()

      this.$store.dispatch(AUTH_REFRESH).then(() => {
        this.expireConfirmActive = false
        this.startCounter()
      })
    },
    stopCounter: function () {
      if (this.counterId) {
        clearInterval(this.counterId)
      }
    },
    startCounter: function () {
      var vm = this

      this.refreshing = false

      if (this.counterId) {
        clearInterval(this.counterId)
      }

      // Every 10 secs
      this.counterId = setInterval(function () {
        vm.$store.dispatch(CHECK_TOKEN)
          .then((res) => {
            vm.tokenExpiresIn = res.expire || 0

            // console.log('A, Expires in: ', vm.tokenExpiresIn)

            if (res.expire <= 0) {
              sessionStorage.autologout = true
              vm.onExpireCancel()
            } else if (res.expire <= ALERT_SECS) {
              vm.expireConfirmActive = true
              vm.startAlertCounter()
            } else {
              vm.expireConfirmActive = false
            }
          })
          .catch((err) => {
            console.log('Err', err)
            sessionStorage.autologout = true
            vm.onExpireCancel()
          })
      }, 10000)
    },
    startAlertCounter: function () {
      const vm = this

      if (this.counterId) {
        clearInterval(this.counterId)
      }

      // Every 1 sec
      this.counterId = setInterval(function () {
        vm.$store.dispatch(CHECK_TOKEN)
          .then((res) => {
            vm.tokenExpiresIn = res.expire || 0

            // console.log('B, Expires in: ', vm.tokenExpiresIn)

            if (res.expire <= 0) {
              sessionStorage.autologout = true
              vm.onExpireCancel()
            } else if (res.expire <= ALERT_SECS) {
              vm.expireConfirmActive = true
            } else {
              vm.expireConfirmActive = false
            }
          })
          .catch((err) => {
            console.log('Err', err)
            sessionStorage.autologout = true
            vm.onExpireCancel()
          })
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
  // Import our global css
  @import './styles/global';

  .atlwdg-trigger {
    z-index: 1000000;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue